import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SchemaMarkup from './components/seo/SchemaMarkup';
import { useTranslation } from 'react-i18next';
import Loading from './components/common/Loading';
import ScrollToHash from './components/common/ScrollToHash';
import HomePage from './pages/HomePage';
import LegalPage from './pages/LegalPage';
import LogoPage from './pages/LogoPage';
import LogoGeneratorPage from './pages/LogoGeneratorPage';
import ZimbraAdminPanelPage from './pages/ZimbraAdminPanelPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PublicLogosPage from './pages/PublicLogosPage';
import ScaleNixOSPage from './pages/ScaleNixOSPage';
import ContactPage from './pages/ContactPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SolutionsPage from './pages/SolutionsPage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import CompanyPage from './pages/CompanyPage';
import TrainingPage from './pages/TrainingPage';
import UniversityPage from './pages/UniversityPage';
import UniversityCoursePage from './pages/UniversityCoursePage';
import LanguageRoute from './components/common/LanguageRoute';
import NotFoundRedirect from './components/common/NotFoundRedirect';

const App: React.FC = () => {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.dir();
  }, [i18n.language]);

  return (
    <HelmetProvider>
      <SchemaMarkup />
      <Suspense fallback={<Loading />}>
        <Router>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:slug" element={<ProductDetailPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/logo" element={<LogoPage />} />
            <Route path="/logo-generator" element={<LogoGeneratorPage />} />
            <Route path="/zimbra-admin-panel" element={<ZimbraAdminPanelPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/pub_signature.png" element={<PublicLogosPage />} />
            <Route path="/public-logos" element={<PublicLogosPage />} />
            <Route path="/scalenix-os" element={<ScaleNixOSPage />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/university" element={<UniversityPage />} />
            <Route path="/university/:id" element={<UniversityCoursePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/en/*" element={<LanguageRoute path="/en/*" />} />
            <Route path="/fr/*" element={<LanguageRoute path="/fr/*" />} />
            <Route path="/de/*" element={<LanguageRoute path="/de/*" />} />
            <Route path="/es/*" element={<LanguageRoute path="/es/*" />} />
            <Route path="/it/*" element={<LanguageRoute path="/it/*" />} />
            <Route path="*" element={<NotFoundRedirect />} />
          </Routes>
        </Router>
      </Suspense>
    </HelmetProvider>
  );
};

export default App;
